<template>
    <DataTable :value="tableData" class="p-datatable-sm" :paginator="true" :rows="rowsPerPage"
        :totalRecords="totalRecords" :first="(currentPage - 1) * rowsPerPage" :rowsPerPageOptions="[5, 10, 20]"
        :lazy="true" @page="onPage" @row-click="onRowClick" style="cursor: pointer;">
        <Column field="checked" header="">
        </Column>
        <Column v-for="(col, index) in columns" :key="index" :field="col.field" :header="col.header"
            :sortable=col.sortable class="whitespace-nowrap" :bodyStyle="{ whiteSpace: 'nowrap' }">
            <template #body="{ data }">
                {{ col.field === 'tutorType' ? cleanupLables(data[col.field]) :
                col.field === 'teachingLanguage' ? (Array.isArray(data[col.field]) ? data[col.field].map(lang =>
                cleanupLables(lang)).join(', ') : (typeof data[col.field] === 'string' ? data[col.field].split(',').map(lang =>
                cleanupLables(lang.trim())).join(', ') : cleanupLables(data[col.field]))) : data[col.field] }}
            </template>
        </Column>
        <Column field="status" header="Status">
            <template #body="{ data }">
                <Button v-if="data.verificationStatus === 'rejected'" label="Rejected"
                    class="p-button-rounded p-button-outlined p-button-danger"  severity="danger" disabled size="small" />
                <Button v-else-if="data.verificationStatus === 'approved'" severity="success" label="Approved"
                    class="p-button-rounded p-button-outlined p-button-success" disabled size="small" />
                <Button v-else label="Pending" class="p-button-rounded p-button-outlined p-button-warning"  severity="warn" disabled
                    size="small" />
            </template>
        </Column>
        <template #paginatorstart>
            <div class="text-sm Caption">
                Showing {{ tableData.length }} of {{ totalRecords }} records
            </div>
        </template>
        <template #empty>
            <div class="flex align-items-center justify-content-center" style="min-height: calc(100vh - 600px)">
                <div class="text-center">
                    <i class="pi pi-inbox" style="font-size: 2rem; color: var(--surface-400)"></i>
                    <p class="mt-2 text-color-secondary">No Data found</p>
                </div>
            </div>
        </template>
    </DataTable>
</template>
<script setup>
import { defineProps, defineEmits } from "vue";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { cleanupLables } from "@/utils/cleanups";
defineProps({
    tableData: null,
    isLoading: Boolean,
    rowsPerPage: Number,
    totalRecords: Number,
    currentPage: Number
})
const emit = defineEmits(["row-click"]);

const onRowClick = (event) => {
    emit("row-click", event.data);
};
const columns = [
    { field: 'username', header: 'Name', sortable: false },
    { field: 'tutorType', header: 'Profession', sortable: false },
    { field: 'teachingLanguage', header: 'Language', sortable: false },
    { field: 'address', header: 'Location', sortable: false },
    { field: 'created_at', header: 'Submitted date', sortable: false },
];

const onPage = (event) => {
    const page = Math.floor(event.first / event.rows) + 1;
    const limit = event.rows;
    emit("page-change", { page, limit });
}

</script>
<style scoped>

.p-datatable .p-column-header-content {
    justify-content: space-between;
}

.p-select {
    --p-select-sm-font-size: 12px;
    --p-select-color: var(--black-700);
    --p-select-hover-border-color: transparent;
    --p-select-border-color: transparent;
    --p-select-focus-border-color: transparent;
}

::v-deep(.p-select-sm .p-select-label) {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
</style>